module.exports = __webpack_public_path__ + "img/bg-page-01.fdf1993b.png";